import React from 'react';

const spaFeatures = ['Massage & Body Therapy', 'Herbal Rituals', 'Sauna & Steam', 'Jacuzzi', 'Meditation'];

function Spa() {
    return (
        <>

            {/* <!-- Header Banner --> */}
            <section className="banner-header bg-img bg-fixed" data-overlay-dark="5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/banner/20.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="subtitle">Black Rock Luxury Hotel</div>
                            <div className="title">Spa & Wellness</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Spa section */}
            <section className="spa-section">

                {/* Intro */}
                <div className="spa-intro">
                    <div className="container">
                        <div className="spa-intro__inner">
                            <div className="spa-intro__text">
                                <div className="spa-intro__label">So Many Ways to Unwind</div>
                                <h2 className="spa-intro__title">Spa & Wellness</h2>
                                <div className="spa-intro__divider" />
                                <p className="spa-intro__desc">
                                    A destination spa experience inspired by nature’s healing power and Mongolia’s wellness traditions.
                                    Reconnect with your senses through curated therapies, herbal rituals, and tranquil environments.
                                </p>
                                <div className="spa-intro__features">
                                    {spaFeatures.map(function(f) { return (
                                        <span key={f} className="spa-intro__feature">
                                            <span className="spa-intro__feature-dot" />
                                            {f}
                                        </span>
                                    ); })}
                                </div>
                            </div>
                            <div className="spa-intro__img-stack">
                                <img src={`${process.env.PUBLIC_URL}/img/banner/23.jpg`} alt="" className="spa-intro__img spa-intro__img--top" />
                                <img src={`${process.env.PUBLIC_URL}/img/banner/24.jpg`} alt="" className="spa-intro__img spa-intro__img--bot" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Full-width image */}
                <div className="spa-fullimg">
                    <img src={`${process.env.PUBLIC_URL}/img/banner/25.jpg`} alt="" />
                    <div className="spa-fullimg__overlay">
                        <div className="spa-fullimg__quote">"Where the body rests and the soul breathes"</div>
                    </div>
                </div>

            </section>

        </>
    );
}

export default Spa;